/*
 * Part of the RubinRed CMS.
 * @author    Paolo Pontarollo <pontarollo@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.it
 */

const ComponentHelpers = {
  install: (Vue, options) => {
    Vue.prototype.hasProp = function (prop) {
      return this.$options.propsData.hasOwnProperty(prop);
    };
    if(options.Utils) {
      Vue.prototype.Utils = options.Utils;
    }
  }
};

export default ComponentHelpers;



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/utils/ComponentHelpers.js